import Typography from "@/design-system/Typography";
import { CbTopBaseResources } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources";
import { CbTopBaseResourcesEn } from "@/src/cashback/LandingPage/Version/cb-top-base.Resources.En";
import { languageSelector } from "@/src/contexts";
import { ConsentScreenType } from "@/src/modals/useConsents";
import PanelSection from "@/src/shared/panel-section";
import ImageLoader from "@Components/ImageLoader";
import { LoginRegistrationCore } from "@Components/login-registration-core/login-registration-core";
import { TelemetryBoundary } from "@Components/telemetry-hoc/telemetry-boundary";
import * as stylex from "@stylexjs/stylex";

import { type QuerySmMax } from "./../../../../../styles/tokens.stylex";
import cbImg from "./../_assets/cb_brand.png";

import * as css from "./lpVersionC.module.css";

export function LpTopComponentVersionC() {
    const ME_VERISON = "C";

    const resources = languageSelector(CbTopBaseResources, CbTopBaseResourcesEn);

    return (
        <PanelSection
            telemetryCustom={{
                eventName: "cshbck-TopSection",
                actionType: "View",
                param1: ME_VERISON,
            }}
            className={css.lpVersionC}
            styleX={styles.forceOverflow}
            initialInView
        >
            <div {...stylex.props(styles.CompContainer)}>
                <div className={css.textContent}>
                    <Typography
                        textElement="h1"
                        fontStyle="hXL"
                        styleX={styles.title}
                        dangerouslySetInnerHTML={{ __html: resources.title }}
                    />

                    <Typography textElement="p" fontStyle="hXS">
                        {resources.subTitle}
                    </Typography>

                    <ImageLoader
                        {...stylex.props(styles.imageWrapper)}
                        src={cbImg}
                        alt="Cashback - zwroty pieniędzy za zakupy"
                    />
                </div>

                <TelemetryBoundary
                    className={css.formContainer}
                    telemetryCustom={{
                        eventName: "common-registerModal",
                        actionType: "View",
                        param1: ME_VERISON,
                    }}
                >
                    <LoginRegistrationCore
                        loginConsentScreenType={ConsentScreenType.LoginProcess}
                        registerConsentScreenType={ConsentScreenType.RegistrationProcess}
                        customRegisterButtonTelemetry={{
                            eventName: "cshbck-topSectionRegister",
                            actionType: "Click",
                            param1: ME_VERISON,
                        }}
                    />
                </TelemetryBoundary>
            </div>
        </PanelSection>
    );
}

const smMax: QuerySmMax = "@media (max-width: 989px)";
const styles = stylex.create({
    forceOverflow: {
        overflow: "visible",
    },
    CompContainer: {
        gap: { default: 80, [smMax]: 30 },
        display: "grid",
        gridTemplateColumns: { default: "2fr minmax(400px, 1fr)", [smMax]: "1fr" },
    },
    title: {
        gridRow: { default: "auto", [smMax]: "2/3" },
        fontSize: { default: "64px", [smMax]: "48px" },
        fontWeight: 300,
        marginBottom: { default: 40, [smMax]: 20 },
    },
    imageWrapper: {
        gridRow: { default: "auto", [smMax]: "3/4" },
        marginTop: { default: 60, [smMax]: 0 },
    },
});
